import React from 'react';
import type { FC } from 'react';

import { DropdownItem } from '@atlaskit/dropdown-menu';
import { SimpleTag } from '@atlaskit/tag';

import { fg } from '@confluence/feature-gating';
import type { DialogsStateContainer } from '@confluence/dialogs/entry-points/DialogsStateContainer.ts';

import { useLabelsDescriptionText } from './useLabelsDescriptionText.ts';
import { EditLabelDialogLoader } from './EditLabelDialogLoader.ts';
import type { EditLabelDialogComponentProps } from './EditLabelDialogComponent.tsx';

type EditLabelsDropdownItemProps = {
	contentId: string;
	spaceKey: string;
	dialogs: DialogsStateContainer;
};
export const EditLabelDropdownItem: FC<EditLabelsDropdownItemProps> = ({
	contentId,
	spaceKey,
	dialogs,
}) => {
	const buttonText = useLabelsDescriptionText({ contentId });

	const showEditLabelDialog = () => {
		const dialogProps: EditLabelDialogComponentProps = {
			contentId,
			spaceKey,
			source: 'fabricEditor',
		};
		dialogs.showModal(EditLabelDialogLoader, dialogProps);
	};

	return (
		<DropdownItem key="edit-labels" onClick={showEditLabelDialog}>
			{fg('confluence_fronend_labels_categorization_migration') ? (
				<SimpleTag text={buttonText} color="standard" />
			) : (
				buttonText
			)}
		</DropdownItem>
	);
};
